<template>
  <b-modal
    id="modal-newUser"
    ref="modal-newUser"
    title="Nouvel utilisateur"
    hide-footer
  >
    <b-container>
      <b-row align-h="center" class="mt-5 mb-5">
        <b-col cols="12">
          <b-card class="p-3">
            <!-- <h3 class="mb-4">Login</h3> -->
            <b-form @submit.prevent="onSubmit">
              <b-form-group
                id="exampleInputGroup1"
                label="Email address:"
                label-for="exampleInput1"
              >
                <b-form-input
                  id="exampleInput1"
                  type="email"
                  v-model="form.email"
                  required
                  placeholder="Email"
                >
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="exampleInputGroup2"
                label="Password:"
                label-for="exampleInput2"
                v-if="!user"
              >
                <b-form-input
                  id="exampleInput2"
                  type="password"
                  v-model="form.password"
                  required
                  placeholder="Password"
                >
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="exampleInputGroup3"
                label="Role"
                label-for="exampleInput2"
              >
                <b-form-select
                  v-model="form.role"
                  :options="options"
                ></b-form-select>
              </b-form-group>
              <b-form-group
                id="exampleInputGroup2"
                label="Datas"
                label-for="exampleInput2"
                v-if="user"
              >
                <b-form-textarea
                  id="exampleInput2"
                  v-model="form.datas"
                  rows=10
                  disabled
                >
                </b-form-textarea>
              </b-form-group>
              <div>
                <b-button block type="submit" variant="primary">Submit</b-button
                >&nbsp;
              </div>
              <div class="mt-5 d-flex justify-content-center" v-if="isLoading">
                <b-spinner variant="success"></b-spinner>
              </div>
              <b-alert show v-if="message" dismissible variant="warning"
                >{{ message }}
              </b-alert>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
export default {
  name: "ModalCreateEditUser",
  props: {
    user: Object,
  },
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      isLoading: false,
      edit: false,
      selected: "",
      message: "",
      options: [
        { value: "admin", text: "Admin" },
        { value: "user", text: "Utilisateur" },
      ],
    };
  },
  created() {
    console.log(this.user);

    if (this.user) {
      this.form = this.user;
    }
  },
  methods: {
    async onSubmit() {
      this.isLoading = true;
      let res;
      if (this.user) {
        res = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/api/v1/adminUsers/editUser`,
          {
            method: "POST",
            body: JSON.stringify(this.form),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.localStorage.token}`
            },
          }
        );
      } else {
        res = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/api/v1/adminUsers/adminSignup`,
          {
            method: "POST",
            body: JSON.stringify(this.form),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.localStorage.token}`

            },
          }
        );
      }

      const data = await res.json();
      // .then((data) => {
      // console.log(data);
      if (data.status === "success") {
        this.message = data.message;
        this.form = {
          email: "",
          password: "",
        };
      }

      if (data.errors?.length) {
        this.message = data.errors[0].msg;
      }
      this.isLoading = false;
      // })
      // .catch((err) => {
      //   this.isLoading = false;
      //   console.log(err);
      // });
    },
  },
};
</script>

<style></style>
